
 export function processDefaultScores(data, evaluationform, TicketCalc)  {
    const sectionScores = {};
    const notMetScores = {};

    // Calculate section-wise totals (excluding "FE" values)
    const sectionwiseTotal = data.reduce((sectionSum, entry) => {
      const { sectionName, questionscore, ParameterType } = entry;

      // Skip "FE" parameter type and ensure questionscore is a valid number
      if (ParameterType !== "FE" && typeof questionscore === 'number' && !isNaN(questionscore)) {
        if (!sectionSum[sectionName]) {
          sectionSum[sectionName] = 0;
        }
        sectionSum[sectionName] += questionscore;
      } else {
        // Log if the entry is invalid (for debugging)
        // console.log('Skipping invalid score entry:', entry);
      }
      return sectionSum;
    }, {});
    const allSections = [...new Set(data.map(entry => entry.sectionName))]; // Get unique section names
allSections.forEach(section => {
  if (!sectionScores[section]) {
    sectionScores[section] = 0;  // Ensure all sections exist with value 0
  }
});
    data.forEach((entry) => {
      const { sectionName, questionscore, assessment, ParameterType } = entry;
      // console.log('Processed entry:', entry);
      if (typeof questionscore !== 'number' || isNaN(questionscore)) {
        // console.log('Skipping invalid score for section:', sectionName, questionscore);
      }
      // If the ParameterType is "FE", skip the score processing
      if (ParameterType === "FE") {
        return;
      }

      // If the assessment is "Met", add the score to sectionScores
      if (assessment === "Met" || assessment === 'Met Expectations' || assessment === 'Yes') {
        if (!sectionScores[sectionName]) {
          sectionScores[sectionName] = 0;
        }
        sectionScores[sectionName] += questionscore;
      }

      // If the assessment is "Not Met", add the score to both sectionScores and notMetScores
      else if (assessment === "Not Met" || assessment === "Unsatisfactory" || assessment === "No") {
        if (!sectionScores[sectionName]) {
          sectionScores[sectionName] = 0;
        }
        sectionScores[sectionName] += questionscore;

        if (!notMetScores[sectionName]) {
          notMetScores[sectionName] = 0;
        }
        notMetScores[sectionName] += questionscore;
      }

      else if (assessment === "N/A" || assessment === "NA") {
        if (!notMetScores[sectionName]) {
          notMetScores[sectionName] = 0;
        }
        notMetScores[sectionName] += questionscore;
      }

    else if (assessment === "Partially Met" || assessment === 'Needs Improvement') {
  const halfScore = questionscore / 2;

  // Add full to sectionScores
  if (!sectionScores[sectionName]) {
    sectionScores[sectionName] = 0;
  }
  sectionScores[sectionName] += questionscore;

  // Add HALF to notMetScores (for deduction purposes)
  if (!notMetScores[sectionName]) {
    notMetScores[sectionName] = 0;
  }
  notMetScores[sectionName] += halfScore;
}

  
    });

    // Subtract notMetScores from sectionwiseTotal
    const sectionwiseTotalMinusNotMet = {};
    Object.keys(sectionwiseTotal).forEach((section) => {
      const totalScore = sectionwiseTotal[section];
      const notMetScore = notMetScores[section] || 0;  // If no Not Met score, treat as 0
      sectionwiseTotalMinusNotMet[section] = totalScore - notMetScore;
    });

    // Calculate percentage for each section
    const sectionPercentages = {};
    Object.keys(sectionwiseTotalMinusNotMet).forEach((section) => {
      const totalScoreMinusNotMet = sectionwiseTotalMinusNotMet[section];
      const sectionScore = sectionScores[section] || 0;  // If no score, treat as 0

      // Avoid division by zero
      let percentage = 0;
      if (sectionScore !== 0) {
        percentage = Math.floor((totalScoreMinusNotMet / sectionScore) * 100);  // Round down
      }

      // Check how many "FE" entries with "Not Met" exist in this section
      const feNotMetEntries = data.filter(entry => entry.sectionName === section && entry.ParameterType === "FE" && entry.assessment === "Not Met");

      // Subtract 20 for each "FE" "Not Met" entry found
      if (feNotMetEntries.length > 0) {
        percentage -= feNotMetEntries.length * 20;
        // Ensure percentage doesn't go below 0
        if (percentage < 0) {
          percentage = 0;
        }
      }

      sectionPercentages[section] = percentage;
    });


//     // Calculate summary percentage based on adjusted section scores
//     let totalScore = 0;
//     let ChangedScore = 0;

//     Object.keys(sectionwiseTotalMinusNotMet).forEach((section) => {
//       if (section === "Zero Tolerance") return;
//       const sectionScore = sectionScores[section] || 0; // Already adjusted score
//       const sectionChangedScore = sectionwiseTotalMinusNotMet[section] || 0; // Max possible score after removing "Not Met"

//       // Debugging each section's individual scores and max scores

//       totalScore += sectionScore;
//       ChangedScore += sectionChangedScore;
//     });

//     // Debug the final summary

//     let summaryPercentage = ChangedScore > 0 ? Math.round((ChangedScore / totalScore) * 100) : 0;

//     // Debug the final percentage

//     // Count the "NF" and "FE" "Not Met" entries
//     const nfNotMetCount = data.filter(entry => entry.ParameterType === "NF" && entry.assessment === "Not Met").length;
//     const feNotMetCount = data.filter(entry => entry.ParameterType === "FE" && entry.assessment === "Not Met").length;


//     // Reduce the summary percentage by 20 for each "FE" "Not Met" entry
//     summaryPercentage -= feNotMetCount * 20;

//     // Ensure summary percentage doesn't go below 0
//     if (summaryPercentage < 0) {
//       summaryPercentage = 0;
//     }
// const zeroToleranceNoFound = data.some(entry => entry.sectionName === "Zero Tolerance" && entry.assessment === "No");
//   if (zeroToleranceNoFound) {
//     summaryPercentage = 0;
//   }

// Calculate summary percentage based on adjusted section scores
let totalScore = 0;
let ChangedScore = 0;

// console.log('--- Summary Calculation Start ---');
Object.keys(sectionwiseTotalMinusNotMet).forEach((section) => {
  if (section === "Zero Tolerance") {
    // console.log(`Skipping section "${section}" in summary calculation`);
    return;
  }

  const sectionScore = sectionScores[section] || 0;
  const sectionChangedScore = sectionwiseTotalMinusNotMet[section] || 0;



  totalScore += sectionScore;
  ChangedScore += sectionChangedScore;
});


let summaryPercentage = ChangedScore > 0 ? parseFloat(((ChangedScore / totalScore) * 100).toFixed(2)) : 0;

const nfNotMetCount = data.filter(entry => entry.ParameterType === "NF" && entry.assessment === "Not Met").length;
const feNotMetCount = data.filter(entry => 
  (entry.ParameterType === "FE" && entry.assessment === "Not Met") ||
  (entry.ParameterType === "ZT" && entry.assessment === "No")
).length;

summaryPercentage -= feNotMetCount * 20;

if (summaryPercentage < 0) {
  summaryPercentage = 0;
}

const zeroToleranceNoFound = data.some(entry => entry.sectionName === "Zero Tolerance" && entry.assessment === "No");
if (zeroToleranceNoFound) {
  // console.log('Zero Tolerance section has an assessment "No", setting summaryPercentage to 0');
  summaryPercentage = 0;
}

const hasZTParameter = data.some(entry => entry.ParameterType === "ZT" && (entry.assessment === "No" || entry.assessment === "Not Met"));
if (hasZTParameter) {
  summaryPercentage = 0;
}

const isGSDForm = evaluationform === "GSD Ticket Audit Form" && TicketCalc !== 'IncludeTicket';
const hasForcedFail = isGSDForm && data.some(entry =>
  entry.sectionName !== "Zero Tolerance" &&
  entry.sectionName !== "Summary" &&
  (entry.assessment === "Not Met" || entry.assessment === "No")
);

const finalStatus = hasForcedFail || summaryPercentage < 90 ? 'Fail' : 'Pass';

// console.log('sectionScores',sectionScores)
    return { sectionScores, notMetScores, sectionwiseTotal, sectionwiseTotalMinusNotMet, sectionPercentages, summaryPercentage, nfNotMetCount, feNotMetCount, finalStatus };
  };

 export function processMalaysiaScores(data) {
  const sectionScores = {};
  const notMetScores = {};

  // Calculate section-wise total including FE scores (max points)
  const sectionwiseTotal = data.reduce((totals, { sectionName, questionscore }) => {
    if (typeof questionscore === 'number' && !isNaN(questionscore)) {
      totals[sectionName] = (totals[sectionName] || 0) + questionscore;
    }
    return totals;
  }, {});

  // Calculate sectionScores including FE scores
  data.forEach(({ sectionName, questionscore, assessment }) => {
    if (typeof questionscore !== 'number' || isNaN(questionscore)) return;

    if (assessment === "Met" || assessment === 'Met Expectations' || assessment === 'Yes') {
      sectionScores[sectionName] = (sectionScores[sectionName] || 0) + questionscore;
    } else if (assessment === "Not Met" || assessment === "Unsatisfactory" || assessment === "No") {
      sectionScores[sectionName] = (sectionScores[sectionName] || 0) + questionscore;
      notMetScores[sectionName] = (notMetScores[sectionName] || 0) + questionscore;
    } else if (assessment === "N/A" || assessment === "NA") {
      notMetScores[sectionName] = (notMetScores[sectionName] || 0) + questionscore;
    }  else if (assessment === "Partially Met" || assessment === 'Needs Improvement') {
  const halfScore = questionscore / 2;

  // Add full to sectionScores
  if (!sectionScores[sectionName]) {
    sectionScores[sectionName] = 0;
  }
  sectionScores[sectionName] += questionscore;

  // Add HALF to notMetScores (for deduction purposes)
  if (!notMetScores[sectionName]) {
    notMetScores[sectionName] = 0;
  }
  notMetScores[sectionName] += halfScore;
    }
  });

  // Calculate sectionwiseTotalMinusNotMet = total max points - notMetScores
  const sectionwiseTotalMinusNotMet = {};
  for (const section in sectionwiseTotal) {
    const notMet = notMetScores[section] || 0;
    sectionwiseTotalMinusNotMet[section] = sectionwiseTotal[section] - notMet;
  }

  // Find all sections where FE is Not Met
  const malaysiaFESections = new Set(
    data
      .filter(entry => entry.ParameterType === "FE" && entry.assessment === "Not Met")
      .map(entry => entry.sectionName)
  );

  // Zero out score and max points for these sections
  malaysiaFESections.forEach(section => {
   // sectionScores[section] = 0;
    sectionwiseTotalMinusNotMet[section] = 0;
  });

  // Calculate section percentages (normal formula, no 100 override here)
  const sectionPercentages = {};
  for (const section in sectionwiseTotalMinusNotMet) {
    const maxPoints = sectionwiseTotalMinusNotMet[section];
    const score = sectionScores[section] || 0;

    let percentage = 0;
    if (score !== 0) {
      percentage = Math.floor((maxPoints / score) * 100);
    }
    sectionPercentages[section] = percentage;
  }

  // Summary calculation:
  // If any section maxPoints = 0, treat maxPoints as 100 here ONLY
 let totalScore = 0;
let changedScore = 0;

// console.log("---- Summary Debug Start ----");
Object.keys(sectionwiseTotalMinusNotMet).forEach(section => {
  let maxPoints = sectionScores[section] || 0;
  let score = sectionwiseTotalMinusNotMet[section] || 0;

  // if (malaysiaFESections.has(section)) {
  //   // This section has FE Not Met, adjust maxPoints for summary only
  //   const adjustedMaxPoints = maxPoints === 0 ? 100 : maxPoints;
  //   const adjustedScore = score; // score stays as is, zero allowed

  //   totalScore += adjustedMaxPoints;
  //   changedScore += adjustedScore;

  //   console.log(`Section: ${section} (FE Not Met)`);
  //   console.log(`  Original sectionScore: ${score}`);
  //   console.log(`  Original maxPoints: ${maxPoints}`);
  //   console.log(`  Adjusted maxPoints (for summary): ${adjustedMaxPoints}`);
  //   console.log(`  Adjusted sectionScore (for summary): ${adjustedScore}`);
  // } else {
    // Normal section with no FE Not Met
    totalScore += maxPoints;
    changedScore += score;

    // console.log(`Section: ${section} (No FE Not Met)`);
    // console.log(`  sectionScore: ${score}`);
    // console.log(`  maxPoints: ${maxPoints}`);
 // }
});

let summaryPercentage = changedScore > 0 ? parseFloat(((changedScore / totalScore) * 100).toFixed(2)) : 0;
if (summaryPercentage > 100) summaryPercentage = 100;

// console.log(`Total Max Points (denominator): ${totalScore}`);
// console.log(`Total Earned Scores (numerator): ${changedScore}`);
// console.log(`Final Summary Percentage: ${summaryPercentage}`);
// console.log("---- Summary Debug End ----");

const hasZTParameter = data.some(entry => entry.ParameterType === "ZT" && (entry.assessment === "No" || entry.assessment === "Not Met"));
if (hasZTParameter) {
  summaryPercentage = 0;
}
  

  // Count NF and FE Not Met entries (optional, for info)
  const nfNotMetCount = data.filter(entry => entry.ParameterType === "NF" && entry.assessment === "Not Met").length;
 // const feNotMetCount = malaysiaFESections.size;
const feNotMetCount = data.filter(entry => 
  (entry.ParameterType === "FE" && entry.assessment === "Not Met") ||
  (entry.ParameterType === "ZT" && entry.assessment === "No")
).length;
  const finalStatus = summaryPercentage < 90 ? 'Fail' : 'Pass';

  return {
    sectionScores,
    notMetScores,
    sectionwiseTotal,
    sectionwiseTotalMinusNotMet,
    sectionPercentages,
    summaryPercentage,
    nfNotMetCount,
    feNotMetCount,
    finalStatus,
    malaysiaFESections: Array.from(malaysiaFESections),
  };
}






export function processScores(data, site, evaluationform, TicketCalc) {
  if (site === "Malaysia") {
    return processMalaysiaScores(data);
  } else {
    return processDefaultScores(data, evaluationform,TicketCalc);
  }
};